<template>
    <div class="row flex justify-content-center contact_block" id="contact-block-help-footer">

        <dudas-component :section="this.section"></dudas-component>

        <div class="col-12">
            <h1 class="main_title">
                ¿No encuentras respuesta a tu consulta?<br>
                <span>Contáctanos</span>
            </h1>
            <div class="">
                <div class="row">
                    <div class="col-sm-4 col-12 item">
                        <img src="/img/iconos/ayuda/icon_sobre.svg" alt="icon_sobre.svg">
                        <h2 class="title">Envíanos un email</h2>
                        <p class="text">Te responderemos en la mayor brevedad.</p>
                        <a class="button" @click="openInfoWindow('contacto_form')">
                            <span>Escríbenos</span>
                            <img src="/img/iconos/ayuda/icon_flecha.svg" alt="icon_flecha.svg" style="width: 25px;float: right;padding: 8px 0px;">
                        </a>
                        <windows-info v-cloak ref="contacto_form" back-color="grey" in-product="false">
                            <div slot="header">
                                <h4 class="title" style="height: auto;text-align: center;">
                                    Escríbenos
                                </h4>
                            </div>
                            <div slot="button">
                                <a class="alter-btn-green">
                                    <span>
                                        Rellenar formulario
                                    </span>
                                </a>
                            </div>
                            <div slot="agradecimiento">
                                <div class="py-5 px-1">
                                    <h2 class="title">¡Gracias por contactar con Babyplant!</h2>
                                </div>
                            </div>
                        </windows-info>
                    </div>
                    <div class="col-sm-4 col-12 item">
                        <img src="/img/iconos/ayuda/icon_atenciocliente.svg" alt="icon_atenciocliente.svg">
                        <h2 class="title">Llámanos</h2>
                        <p class="text">Nuestros especialistas están a tu disposición.</p>
                        <b-button class="button" id="contacto_telefonico">
                            <span>Llámanos</span>
                            <img src="/img/iconos/ayuda/icon_flecha.svg" alt="icon_flecha.svg" style="width: 25px;float: right;padding: 8px 0px;">
                        </b-button>
                        <b-popover target="contacto_telefonico" placement="top" custom-class="popover_contacto_zone grey_style" triggers="click focus">
                            <a href="tel:968862244">968 86 22 44</a>
                        </b-popover>
                    </div>
                    <div class="col-sm-4 col-12 item">
                        <img src="/img/iconos/ayuda/icon_mensaje.svg" alt="icon_mensaje.svg">
                        <h2 class="title">Chatea con nosotros</h2>
                        <p class="text">Estamos aquí para responder a tus preguntas.</p>
                        <a href="javascript:void(Tawk_API.toggle())" class="button">
                            <span>Comienza el chat</span>
                            <img src="/img/iconos/ayuda/icon_flecha.svg" alt="icon_flecha.svg" style="width: 25px;float: right;padding: 8px 0px;">
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['section'],
        data() {
            return {
            }
        },
        mounted: function () {
        },
        methods: {
            openInfoWindow: function (ventana) {
                var window = this.$refs[ventana];
                console.log(window);
                window.active=!window.active;
                window.activeForm=true;
                window.unstyled=true;
            }
        }
    }
</script>
